import { IPayemntsList } from '../types/PayemntsList';

/**
 * Способы оплаты приходят из `/branch/payment-list` как `{ id, text }`.
 *
 * Здесь нет решения, ПОКАЗЫВАТЬ ли способ, — это решает только ответ бэкенда.
 * Здесь лишь то, КАК с ним работать: оплата картой требует выбрать
 * сохранённую карту (`card_id`), наличным нужна своя иконка и подпись, а
 * онлайн-оплату в аналитике отличаем от списания с карты. Всё, что не
 * опознано, — обычный способ: уходит его `id`, подпись берётся из ответа.
 */
export type PaymentKind = 'card' | 'cash' | 'online' | 'other';

/** Оплата привязанной картой: у бэкенда это способ с id 58. */
const CARD_PAYMENT_ID = 58;
const CARD_TEXT = /^(card|карт|karta)/i;
const CASH_TEXT = /налич|cash|naqd/i;
const ONLINE_TEXT = /онлайн|online|onlayn|multicard|multibank|payme|click|uzum/i;
// Подпись, которую бэкенд даёт оплате по ссылке Multicard («Multibank-Online»),
// пользователю ничего не говорит — показываем свою.
const GENERIC_ONLINE_TEXT = /онлайн|online|onlayn|multicard|multibank/i;

export const getPaymentKind = (method: IPayemntsList): PaymentKind => {
  if (method.id === CARD_PAYMENT_ID || CARD_TEXT.test(method.text)) return 'card';
  if (CASH_TEXT.test(method.text)) return 'cash';
  if (ONLINE_TEXT.test(method.text)) return 'online';
  return 'other';
};

/** Подпись Multicard заменяем на «Оплата онлайн», остальные — как пришли. */
export const isGenericOnlineTitle = (title: string) =>
  GENERIC_ONLINE_TEXT.test(title);

/**
 * Оплата по ссылке — по подписи способа. У заказа бэкенд отдаёт её в
 * `last_payment_title` («Multibank-Online»), и это единственный признак
 * онлайн-оплаты в списке заказов.
 */
export const isOnlinePaymentTitle = (title: string) => ONLINE_TEXT.test(title);

/** Метка способа для аналитики (Mindbox, Firebase). */
export const getPaymentAnalyticsType = (method: IPayemntsList) => {
  const kind = getPaymentKind(method);

  return kind === 'card' || kind === 'online' ? kind : method.text;
};

/**
 * Наличные для самовывоза — там выбора способа нет, заказ всегда уходит
 * наличными. Запасной вариант — прежний индекс: если подпись придёт на языке,
 * которого нет в шаблоне, поведение хотя бы не станет хуже, чем было.
 *
 * Для доставки не использовать: там показывается ровно branch/payment-list.
 */
export const resolveCashPayment = (
  list: IPayemntsList[]
): IPayemntsList | undefined =>
  list.find(item => CASH_TEXT.test(item.text)) ?? list[1];
